import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

function startCollapsed() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true ||
    window.innerWidth < 768
  );
}

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(!startCollapsed());
  const toggle = () => setSidebarOpen(v => !v);

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden">
      {/* Overlay escuro no mobile quando sidebar aberta */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <Sidebar open={sidebarOpen} onToggle={toggle} />

      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Header onToggle={toggle} sidebarOpen={sidebarOpen} />
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
